import "rxjs/add/operator/toPromise";

import { Injectable } from "@angular/core";

import { Api } from "../../api/api";

@Injectable()
export class User {
  approval_modul_selected: any;

  _user: any;
  is_login = 0;
  akses: any = {};
  data: any = {};
  group: any = {};
  player_id: any = "";
  onesignal_app_id: any = "";
  modul_id = "";
  hak_akses_modul: any;
  list_shortcut: any = {};
  tokenMapbox =
    "pk.eyJ1IjoibXlyYWRpYW50IiwiYSI6ImNrNnEzNm9wazFzc3YzbW55MHpjOHE1MHgifQ.U6Gzg9655morfGOck629hw"; //oficial my radiant
  // tokenMapbox= 'sk.eyJ1IjoiaGFuYWZpcSIsImEiOiJjazZxMzB0N3oxbm1yM2xycmZqdTNzcTJnIn0.Fx7DU70dlwlFIB5iqHSohQ'; // hanafiq account
  constructor(public api: Api) {}

  /**
   * Send a POST request to our login endpoint with the data
   * the user entered on the form.
   */
  login(accountInfo: any) {
    accountInfo.modul_id = this.modul_id;
    let seq = this.api.post("index.php/login", accountInfo);
    return seq;
  }

  /**
   * Send a POST request to our signup endpoint with the data
   * the user entered on the form.
   */
  signup(accountInfo: any) {
    let seq = this.api.post("signup", accountInfo);

    return seq;
  }

  /**
   * Log the user out, which forgets the session
   */
  logout(params) {
    this._user = null;
    return this.api.post("index.php/login/logout", params);
  }

  /**
   * Process a login/signup response to store user data
   */
  _loggedIn(resp) {
    this._user = resp.user;
  }

  setSubscription(params) {
    return this.api.post("index.php/login/set_subscription", params);
  }

  requestEditEmployee(params?: any) {
    return this.api.post(
      "index.php/myradiant/Profil/requestEditEmployee",
      params
    );
  }

  getListShortcut(params?: any) {
    return this.api.get("index.php/myradiant/Simplelist/shortcut", params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/myradiant/user/user.ts